exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg.icon{fill:currentColor;height:1em;margin-bottom:.125em;vertical-align:middle;width:1em}svg.icon-spin{animation:icon-spin 2s linear infinite}@keyframes icon-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);

// exports
